import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BigCheckboxColorVariant, BigCheckboxComponent, ToothSide } from '@libs/ui-lib';
import { NgTemplateOutlet } from '@angular/common';
import { PerioMeasurementFormGroup, PerioMeasurementSurface } from '../perio-config/perio-config.vm';

@Component({
  selector: 'lib-perio-boolean-config-measurement',
  imports: [ReactiveFormsModule, BigCheckboxComponent, NgTemplateOutlet],
  templateUrl: './perio-boolean-config-measurement.component.html',
  styleUrl: './perio-boolean-config-measurement.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PerioBooleanConfigMeasurementComponent {
  public formGroup = input.required<FormGroup<PerioMeasurementFormGroup<boolean>>>();
  public rowLabel = input.required<string>();
  public colorVariant = input<BigCheckboxColorVariant>('red');
  public readonly = input.required<boolean>();
  public side = input.required<ToothSide>();
  public reversed = input.required<boolean>();
  public activeCursor = input<PerioMeasurementSurface | null>();

  protected colorClasses: Record<BigCheckboxColorVariant, string> = {
    red: 'text-states-red',
    orange: 'text-states-orange',
  };
}
